import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=cfbe8942&scoped=true&"
import script from "./StartPage.vue?vue&type=script&lang=js&"
export * from "./StartPage.vue?vue&type=script&lang=js&"
import style0 from "./StartPage.vue?vue&type=style&index=0&id=cfbe8942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbe8942",
  null
  
)

export default component.exports